var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"btn",class:[
    _vm.isOutline + _vm.type,
    _vm.btnSize,
    _vm.block ? 'btn-block' : 'btn-flex',
    { active: _vm.active } ],attrs:{"disabled":_vm.disabled,"aria-pressed":_vm.active,"role":"button","aria-label":_vm.label,"type":"button"}},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('icon',{class:[{ 'mr-2': _vm.label }],attrs:{"icon":_vm.icon}}):_vm._e(),(_vm.label)?_c('div',{staticClass:"btn-label",class:[{ 'ml-2': _vm.menu }]},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }